/**
 * Detects API / auth errors that mean the current session token cannot be used.
 * Used by axios interceptors to force logout instead of leaving the user stuck.
 * Intentionally does NOT match generic "unauthorized" permission failures.
 */
export const isInvalidAuthTokenError = (errorOrData) => {
  if (!errorOrData) return false;

  const candidates = [
    errorOrData.message,
    errorOrData.error,
    errorOrData.name,
    errorOrData.code,
    typeof errorOrData === 'string' ? errorOrData : null,
  ]
    .filter(Boolean)
    .map((value) => String(value).toLowerCase());

  return candidates.some((value) =>
    value.includes('invalid token') ||
    value.includes('jwt malformed') ||
    value.includes('jsonwebtokenerror') ||
    value.includes('tokenexpirederror')
  );
};
